import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import TablePagination from "../../../common/pagination/TablePagination";
import TableError from "../../common/TableError";
import TableSkeleton from "../../common/TableSkeleton";
import RefreshButtonTable from "../../../common/RefreshButtonTable";
import { useGetAllAnnouncements } from "../../../../hooks/organization/notification/useGetAllAnnouncements";
import { ITEMS_PER_PAGE } from "../../../../constant/constant";

const ReceivedNotificationTable = ({ initialReadStatus = "all" }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [readStatus, setReadStatus] = useState(initialReadStatus);
  const navigate = useNavigate();

  const { announcements, meta, loading, error, getAllAnnouncements } =
    useGetAllAnnouncements();

  useEffect(() => {
    getAllAnnouncements({ page: currentPage, read_status: readStatus });
  }, [currentPage, readStatus]);

  const handleRefresh = () => {
    getAllAnnouncements({ page: currentPage, read_status: readStatus });
  };

  const handleFilterChange = (status) => {
    setReadStatus(status);
    setCurrentPage(1);
  };

  // Truncate description if too long
  const truncateText = (text, maxLength = 80) => {
    if (!text) return "-";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleView = (announcement) => {
    const basePath = "/school-admin/notification/received";
    navigate(`${basePath}/${announcement.id}`);
  };

  // Show skeleton only on initial load
  if (loading && announcements === undefined) {
    return <TableSkeleton rows={ITEMS_PER_PAGE} columns={4} />;
  }

  if (error || announcements === null) {
    return (
      <TableError
        error={error}
        handleRefresh={handleRefresh}
        loading={loading}
      />
    );
  }

  if (!announcements || announcements.length === 0) {
    return (
      <div>
        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
          <select
            className="form-select"
            style={{ width: "auto" }}
            value={readStatus}
            onChange={(e) => handleFilterChange(e.target.value)}
          >
            <option value="all">All</option>
            <option value="unread">Unread</option>
            <option value="read">Read</option>
          </select>
          <RefreshButtonTable handleRefresh={handleRefresh} loading={loading} />
        </div>
        <div className="alert alert-info mt-3" role="alert">
          No announcements received yet.
        </div>
      </div>
    );
  }

  const totalPages = meta?.last_page || 1;

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
        <select
          className="form-select"
          style={{ width: "auto" }}
          value={readStatus}
          onChange={(e) => handleFilterChange(e.target.value)}
        >
          <option value="all">All</option>
          <option value="unread">Unread</option>
          <option value="read">Read</option>
        </select>
        <RefreshButtonTable handleRefresh={handleRefresh} loading={loading} />
      </div>

      <div className="custom-table-container mt-3">
        <div className="custom-table-wrapper">
          <Table hover className="custom-table">
            <thead className="custom-table-head">
              <tr>
                <th className="notification-col-title">Title</th>
                <th className="notification-col-desc">Description</th>
                <th className="notification-col-date">Received Date</th>
                <th className="notification-col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {announcements.map((announcement) => (
                <tr key={announcement.id}>
                  <td className="notification-col-title">{announcement.title || "-"}</td>
                  <td className="notification-col-desc">{truncateText(announcement.description)}</td>
                  <td className="notification-col-date text-nowrap">{formatDate(announcement.created_at)}</td>
                  <td className="notification-col-action text-center">
                    <button
                      onClick={() => handleView(announcement)}
                      className="notification-table-view-btn"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                      }}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <TablePagination
          totalPage={totalPages}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default ReceivedNotificationTable;
